module.exports = __webpack_public_path__ + "assets/big_green_check-ca6bc0.svg";